<template>
    <div>
        <!-- 需求详情 -->
		<el-dialog title="需求详情" :visible="demandDetailVisible" @close="initData">
            <el-form :label-position="'left'" label-width="150px" >
                <el-form-item label="标题" >
                    <div>{{demandDetail.title}}</div>
                </el-form-item>
                <el-form-item label="描述" >
                    <div>{{demandDetail.content}}</div>
                </el-form-item>
                <el-form-item label="发布方" >
                    <div>{{demandDetail.user_info.realname?demandDetail.user_info.realname:demandDetail.user_info.nickname}}</div>
                </el-form-item>
                <el-form-item label="头像" >
                    
                    <div> <img :src="demandDetail.user_info.photo_url" alt="" style="width:60px;border-radius:50%;height:60px;object-fit:cover"></div>
                </el-form-item>
                <el-form-item label="手机" >
                    <div>{{demandDetail.user_info.phone}}</div>
                </el-form-item>
                <el-form-item label="浏览" >
                    <div>{{demandDetail.browse_num}}</div>
                </el-form-item>
                <el-form-item label="关注" >
                    <div>{{demandDetail.attention_num}}</div>
                </el-form-item>
                <el-form-item label="审核状态" >
                    <div>
                        <el-tag v-show="demandDetail.review==0">未审核</el-tag>
                        <el-tag type="success" v-show="demandDetail.review==1">成功</el-tag>
                        <el-tag type="info" v-show="demandDetail.review==2">拒绝</el-tag>
                    </div>
                </el-form-item>
                <el-form-item label="需求类型" >
                    <div>{{demandDetail.classify_name}}</div>
                </el-form-item>
                <el-form-item label="需求状态" >
                    <div>
                        <el-tag v-show="demandDetail.status==0">筛选中</el-tag>
                        <el-tag type="success" v-show="demandDetail.status==1">对接成功</el-tag>
                    </div>
                </el-form-item>
                <el-form-item label="展示状态" >
                    <div>
                        <el-tag type="info" v-show="demandDetail.is_shop==0">下架</el-tag>
                        <el-tag type="success" v-show="demandDetail.is_shop==1">上架</el-tag>
                    </div>
                </el-form-item>
                <el-form-item label="发布时间" >
                    <div>{{demandDetail.updated_at}}</div>
                </el-form-item>
                
                
            </el-form>
		</el-dialog>
        <!-- 需求详情end -->
    </div>
</template>
<script>
export default {
    props:{
        demandDetailVisible:{
            type:Boolean,
            default:false
        },
        demandDetail:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    data() {
        return {

        }
    },
    methods: {
        initData(){
            this.$emit('update:demandDetailVisible',false)
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/demandDetail.vue